module.exports = __webpack_public_path__ + "img/samoa-logo-icon.a3d9cb2f.png";